/**
 * Copyright (c) 2022, ResMed Inc. All rights reserved.
 */

import { React, useState } from 'react';
import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import Modal from '@material-ui/core/Modal';
import Backdrop from '@material-ui/core/Backdrop';
import Fade from '@material-ui/core/Fade';
import ReactJson from 'react-json-view'
import FormGroup from '@material-ui/core/FormGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import Typography from "@material-ui/core/Typography";
import {CloseButton} from "../common/CommonButtons";
import '../../css/views/CreateResponseJsonView.css'
import '../../css/views/Views.css'
import '../../css/Common.css'
import "../../css/views/ResponseJsonView.css"
import SurveyResponseView from './SurveyResponseView';

export default function ResponseJsonView(props) {

    const [copied, setCopied] = useState(false);
    const [preserveFormattingChecked, setPreserveFormattingChecked] = useState(false);
    const [anchorEl, setAnchorEl] = useState(null);

    /**
     * Functions
     */
    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleMenuClose = () => {
        setAnchorEl(null);
    };

    const handleClose = () => {
        setCopied(false);
        props.setOpen(false);
    };

    const togglePrettyPrint = () => {
        setPreserveFormattingChecked(!preserveFormattingChecked);
    }

    /**
     * Html
     */
    return (
        <>
                <Fade in={props.open}>
                    <div className='views-common-paper'>
                        <div className='views-common-header'>
                            <Typography variant="h5" style={{ margin: "10px" }} gutterBottom>
                                Json View
                            </Typography>
                            <FormGroup row>
                                <Button
                                    variant="outlined"
                                    color={copied ? "#00FF46" : "primary"}
                                    className='common-button'
                                    onClick={() => {
                                        setCopied(true);
                                        const copiedJSON = preserveFormattingChecked ? JSON.stringify(props.details, null, 2) : JSON.stringify(props.details);
                                        navigator.clipboard.writeText(copiedJSON);
                                    }}
                                >
                                    {copied ? "Copied ✓" : "Copy"}
                                </Button>
                                <Button
                                    disabled={typeof props.details.sourceId === "undefined"}
                                    variant="outlined"
                                    color="primary"
                                    className='common-button'
                                    onClick={handleClick}
                                >
                                    Export
                                </Button>
                                <ExportSelection
                                    id="export-selection-menu"
                                    anchorEl={anchorEl}
                                    keepMounted
                                    open={Boolean(anchorEl)}
                                    onClose={handleMenuClose}
                                >
                                    <MenuItem>
                                        <a
                                            className='responseJson-exportSelectionText'
                                            href={`data:text/json;charset=utf-8,${encodeURIComponent(
                                                JSON.stringify(props.details, null, 2)
                                            )}`}
                                            download={`${props.details.sourceId}.json`}
                                        >
                                            JSON File (.json)
                                        </a>
                                    </MenuItem>
                                    <MenuItem>
                                        <a
                                            className='responseJson-exportSelectionText'
                                            href={`data:text/plain;charset=utf-8,${encodeURIComponent(
                                                JSON.stringify(props.details, null, 2)
                                            )}`}
                                            download={`${props.details.sourceId}.txt`}
                                        >
                                            Plain Text (.txt)
                                        </a>
                                    </MenuItem>
                                </ExportSelection>
                            </FormGroup>
                        </div>
                        <div className='responseJson-jsonEditor'>
                            <ReactJson quotesOnKeys={true} src={props.details} displayDataTypes={false} name={null} />
                        </div>
                    </div>
                </Fade>
        </>
    );
}

/**
 * Styles
 */
const ExportSelection = withStyles({
    paper: {
        border: '1px solid #d3d4d5',
    },
})((props) => (
    <Menu
        elevation={0}
        getContentAnchorEl={null}
        anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'center',
        }}
        transformOrigin={{
            vertical: 'top',
            horizontal: 'center',
        }}
        {...props}
    />
));